import React, { Component } from 'react'
import ListHeaders from './helperComponents/listHeaders'
import ListData from './helperComponents/listData'
import Dots from '../activityIndicators/dots'
import './main.css'

class CalismalarimizListComponent extends Component {
    render() {
        if (!this.props.dataCame) {
            return (
                <Dots />
            )
        }
        return (
            <div className="lists-main-border">
                <ListHeaders
                    data={this.props.dataInfo}
                />
                <ListData
                    data={this.props.data}
                    dataInfo={this.props.dataInfo}
                    buttons={this.props.buttons}
                    endPoint={this.props.endPoint}
                />
            </div>
        )
    }
}

export default CalismalarimizListComponent